<template>
  <section v-if="!enableHeroCommunity" :class="titleBelow ? 'hero-heading--title-below' : classes">
    <div :class="titleBelow ? classes : 'hero-heading__content'">
      <pg-breadcrumb
        v-if="!$attrs.iframe && breadcrumb && breadcrumb.label && breadcrumb.link"
        :class="[cssBreadcrumb,$attrs.isHeaderV2 ? 'isHeaderV2' : 'isHeaderV1']"
        :label="breadcrumb.label"
        :link="breadcrumb.link"
        :icon="false"
      />
      <!--<div class="hero-heading__content hero-heading__content--media" v-if="heroMediaDamUrl">
          <pg-image :lazy-src="heroMediaDamUrl"
                    :alt="heroMediaDamName">
          </pg-image>
      </div>-->
      <div class="hero-heading__content hero-heading__content--media" v-if="itemMediaDam || heroMedia">
        <slide-img-video
          :item="heroMedia"
          :itemMobile="heroImageMobile"
          :itemDam="itemMediaDam"
          :itemDamMobile="itemMediaDamMobile"
          :videoMobile="videoMobile"
          :slide-num="slidenum"
          :current-slide="index"
          :autoplayVideo="true"
          :audioVideo="false"
        />
      </div>
      <mini-hero-form
        v-if="ctaLinks.length"
        :brandFormType="brandFormType"
        :ctaLinks="ctaLinks"
        :miniHeroFormTitle="miniHeroFormTitle"
        :miniHeroFormDescription="miniHeroFormDescription"
        :precompiledSet="precompiledSet"
      />
      <div v-if="!titleBelow && !ctaLinks.length" :class="contentTextStyle" :style="{ padding: !(heroMedia || itemMediaDam) && isHeroActive ? '70px 0 0 0' : ''  }">
        <div>
          
          <h1 class="hero-heading__content__title">{{ title }}</h1>
        </div>
      </div>
    </div>
    <h1 v-if="titleBelow && !ctaLinks.length" class="text--heading-xl hero-heading__title text--heading-grid">{{ title }}</h1>
  </section>
</template>

<script>
import PgBreadcrumb from "../Breadcrumb/Breadcrumb.vue";
import SlideImgVideo from "../SlideImgVideo/SlideImgVideo.vue";
import MiniHeroForm from "../MiniHeroForm/MiniHeroForm";
import PgImage from "@wl-components/Image/Image.vue";

export default {
  name: "HeroHeading",
  components: {
      PgImage,
    SlideImgVideo,
    PgBreadcrumb,
    MiniHeroForm
  },
  data() {
    return {
      slidenum: 0,
      index: 0
    };
  },
  props: {
    enableHeroCommunity: {
      type: Boolean,
      default: false
    },
    heroMedia: {
      type: Object,
      default: () => {
      }
    },
    heroMediaDam: {
      type: String
    },
    itemMediaDam: {
      type: Object,
      default: () => {}
    },
    itemMediaDamMobile: {
      type: Object,
      default: () => {}
    },
    heroImageMobile: {
      type: Object,
      default: () => {
      }
    },
    videoMobile: {
      type: Object,
      default: () => {
      }
    },
    breadcrumb: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String
    },
    hideGradient: {
      type: Boolean,
      required: false,
      default: false
    },
    titleBelow: {
      type: Boolean,
      required: false,
      default: false
    },
    precompiledSet: {
      type: Boolean,
      required: false,
      default: false
    },
    miniHeroFormTitle: {
      type: String
    },
    miniHeroFormDescription: {
      type: String
    },
    ctaLinks: {
      type: Array,
      default: () => []
    },
    brandFormType: {
      type: String,
      default: "privateCustomers"
    },
  },
  inheritAttrs: false,
  computed: {
    classes() {
      let variant =
        this.heroMedia && Object.entries(this.heroMedia).length !== 0
          ? "hero-heading--media"
          : "";
      variant += this.ctaLinks.length ? " hero-heading--mini-form" : "";
      return ["hero-heading", variant];
    },
    cssBreadcrumb() {
      return this.heroMedia && Object.entries(this.heroMedia).length !== 0 ? 'button--white' : 'button--black';
    },
    contentTextStyle() {
      return ["hero-heading__content", "hero-heading__content--text", this.hideGradient ? "hero-heading__content--no-bg" : ""]
    },
    isHeroActive() {
      return document.body.classList.contains('hero-active');
    }
  },
  mounted() {
      const ctx = this;
      // ctx.heroMediaDamUrl = ctx?.$root.commonData?.heroMediaDamUrl;

  }
};
</script>
